import React from 'react'
import "./FadeIn.scss"

function FadeIn({Section}) {
  return (
    <div className='fade-in'>
        {Section}
    </div>
  )
}

export default FadeIn